var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M10.161.314 5.995 4.481 1.828.314A1.07 1.07 0 1 0 .314 1.828l4.929 4.93a1.07 1.07 0 0 0 1.514-.001l4.929-4.929a1.07 1.07 0 0 0 0-1.514 1.09 1.09 0 0 0-1.525 0"
})));
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "99fb66811fdab1be03f034437273e570.svg";